import { translate, parseKeyword, keywordText } from '../../ContentTranslation';
import React, { Component } from 'react';
import './CardSelector.css';
import Card from '../../components/cards/Card';
import Library from '../utility/Library';
import { Tooltip } from 'reactstrap';
import Img from '../../StableImage';

import { read, getLanguage } from '../../TextManager';

const statuses = Object.values(Library.statuses);
const lang = getLanguage();

export default class CardSelector extends Component {

  constructor (props) {

    super(props);
    this.canSelect = false;
  }

  componentDidMount() {

    setTimeout(() => this.canSelect = true, 500);
  }

  state = { tooltip: null }

  computeEffect (text, tkey) {

    text = text.replace(/##/g, "");
    let splits = [];
    // eslint-disable-next-line
    let texts = text.split(/\[[^\[]+\]|\{[^\{]+\}|\<[^\<]+\>|\n|D:\d+|B:\d+|M:\d+|F:\d+/);
    // eslint-disable-next-line
    let matches = text.match(/\[[^\[]+\]|\{[^\{]+\}|\<[^\<]+\>|\n|D:\d+|B:\d+|M:\d+|F:\d+/g);
    if (matches)
      matches.forEach((match,i) => {
        let el = match.slice(1, -1);
        splits.push(<span key={i+"a" + "-key-" + tkey}>{ texts[i] }</span>);
        if (match[0] === '{') {
          let el = match.substring(1, match.length - 1);
          let slices = el.split(':');
          let key = slices[0];
          splits.push(<span className="token" onClick={() => this.props.onFocus(Library.cards[key])} key={i + "-key-" + tkey}>{Library.cards[key].name}</span>);
          /*let slices = el.split('/');
          let key = slices[0];
          let ntoken = this.state.token.slice(); ntoken.push(Library.cards[key]);
          let repeat = this.current.key && key === this.current.key.toString();
          splits.push(<span onClick={repeat ? () => {} : () => this.setState({tooltip: null, token: ntoken})} key={i} className={"token" + (repeat ? " repeat-token" : "")} id={'effect-' + i}>{ slices.length > 1 ? translate(slices[1]) : Library.cards[key].name }</span>);*/
        } else if (match[0] === '[') {
          const { keyword } = parseKeyword(el);
          let status = statuses.filter(s => s.translations && s.translations.en.name === keyword)[0];
          splits.push(<span key={i + "-key-" + tkey} className={"keyword" + (status.translations[lang].effect ? "" : " unlabelled") + (status.soft ? " soft" : "")} id={'effect-' + i + "-key-" + tkey} onClick={() => this.toggleTooltip(i)}>{status.keyword ? "" : <Img key={keyword + '-' + i} className="keyword-icon" src={"/images/statuses/" + keyword + ".png"} alt=""/>}{keywordText(el, lang, status.translations[lang].name)}</span>);
          splits.push(<Tooltip key={i+"t" + "-key-" + tkey} className="tooltip" placement="top" isOpen={this.state.tooltip === i + "-" + tkey} target={"effect-" + i + "-key-" + tkey} toggle={() => this.toggleTooltip(i + "-" + tkey)}>{ status.translations[lang].effect }</Tooltip>);
        
        } else if (match[0] === '<') {
          let param = el;
          let value = this.props.options[tkey][el];
          let className = "";
          if (param.includes("damage"))
            className = "num-effect damage-effect";
          else if (param.includes("block"))
            className = "num-effect block-effect";
          else if (param.includes("momentum"))
            className = "num-effect momentum-effect";
          splits.push(<span key={i} className={className}>{value}</span>);
          
        } else if (match[0] === '\n') {
          splits.push(<br key={i + "-key-" + tkey}/>);
        } else if (match[0] === 'D') {
          let initialvalue = parseInt(match.substring(2), 10);
          splits.push(<span key={i + "-key-" + tkey} className="num-effect damage-effect">{ initialvalue }</span>);
        } else if (match[0] === 'B') {
          let initialvalue = parseInt(match.substring(2), 10);
          splits.push(<span key={i + "-key-" + tkey} className="num-effect block-effect">{ initialvalue }</span>);
        } else if (match[0] === 'M') {
          let initialvalue = parseInt(match.substring(2), 10);
          splits.push(<span key={i + "-key-" + tkey} className="num-effect momentum-effect">{ initialvalue }</span>);
        } else if (match[0] === 'F') {
          let initialvalue = parseInt(match.substring(2), 10);
          splits.push(<span key={i + "-key-" + tkey} className="num-effect othervalue-effect">{ initialvalue }</span>);
        }
      });
    splits.push(<span key={"end" + "-key-" + tkey}>{ texts[texts.length-1] }</span>);
    return splits;
  }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {
      
      if (this.tooltipTimeout)
        clearTimeout(this.tooltipTimeout);

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTimeout = setTimeout(() => this.toggleTooltip(null), 3000);
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  effectLength (effect) {

    let length = effect.length;
    if (length > 85)
      return "verylong";
    else if (length > 60)
      return "long";
    return "regular";
  }

  render () {

    if (!this.props.options)
      return <div/>

    return (
      <div className="fight-loot-card-selector">
        <div className="fight-loot-card-options">
        {
          this.props.options.map((option, i) =>
            <div key={i} className="fight-loot-card-option">
              <div className="fight-loot-card-option-card" onClick={() => {
                if (this.canSelect)
                  this.props.onSelect(i);
              }}>
                <div className="fight-loot-card-option-card-inner">
                  <Card level={this.props.level} src={option}/>
                </div>
              </div>
              <div className="game-card-info">
                <div className="game-card-info-inner-selector">
                  <div className="game-card-info-type">{option.type}</div>
                  <div className={"game-card-info-effect game-effect text-" + this.effectLength(option.effect.replace(/##/g, ""))}>{this.computeEffect(option.effect, i)}</div>
                </div>
              </div>
            </div>
          )
        }
        </div>
        { this.props.onSkip ? <div className={"fight-loot-card-skip" /*+ (this.props.text === "Skip" && this.props.run.removes === 0 && this.props.options.length > 1 && !this.props.run.champion.getPassive("cardremovalskip") ? " locked" : "")*/} onClick={() => {
          if (this.canSelect)
            this.props.onSkip();
        }}>{/*this.props.text === "Skip" && this.props.options.length > 1 && !this.props.run.champion.getPassive("cardremovalskip") ? <img src="/images/remove.png"/> : ""*/}{this.props.text}</div> : ""}
      </div>
    );
  }
}

